import React from "react";
import useUserBlogDomains from "../hooks/query/useUserBlogDomains";
import Button from "./base/Button";
import UIActions from "../actions/UIActions";
import AppConstants from "../constants/AppConstants";
import uiPrefix from "../utils/UiPrefixUtils";
import Glyphicon from "./base/Glyphicon";
import SitePublishActions from "../actions/SitePublishActions";
import { openLoadingTab } from "../utils/HTMLUtils";
import styles from "./PreviewPanelModal.module.css";

const BlogPreviewButton = ({ blogPreviewUrl, disabled }) => {
  const { blogDomains = [], isSuccess } = useUserBlogDomains();

  const availableBlogs = blogDomains.filter(
    (blog) => blog.status === AppConstants.BLOG_STATUS_AVAILABLE
  );

  const handleClick = () => {
    // if they've already generated a preview, use cached preview
    if (blogPreviewUrl) {
      window.open(blogPreviewUrl, "_blank");
      return;
    }

    // if they only have one blog, just preview that one
    if (availableBlogs.length === 1) {
      const newTab = openLoadingTab("Preview is generating...");
      // Popup blocked — no tab to send the preview to, so don't start the request.
      if (newTab) {
        SitePublishActions.generateBlogPreview(availableBlogs[0].wp_host_id, newTab);
      }
      return;
    }

    UIActions.modalOpen(AppConstants.MODAL_USER_BLOGS, {});
  };

  return isSuccess && availableBlogs.length > 0 ? (
    <Button
      look="link"
      onClick={handleClick}
      className={`${styles.previewBlogStyles} ${uiPrefix("blog-preview-btn")}`}
      data-e2e={uiPrefix("blog-preview-btn")}
      disabled={disabled}
    >
      <Glyphicon icon="preview" style={{ fontSize: "1.1em", lineHeight: "1.2em" }} />
      &nbsp;&nbsp;View with blog content
    </Button>
  ) : null;
};

export default BlogPreviewButton;
